import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { injectIntl } from 'react-intl';
import { FaTrashAlt, FaShareAlt, FaRegWindowRestore, FaRegEnvelope } from 'react-icons/fa';
import intlShape from '@/shared/utils/intlShape';
import Button from '../../../shared/components/Button';
import messages from '../taskMessages';
import CanDelete from '@/shared/components/security/CanDelete';

const TaskListActionsButton = ({
  task,
  intl,
  onOpenTask,
  onShareItem,
  onSendEmail,
  onDeleteTask,
}) => {
  return (
    <Dropdown id={`task-actions-${task.id}`} className="btn-group-sm btn-group-dropdown" pullRight>
      <Button btnClassName="action-button btn-xs" onClick={() => onOpenTask(task)}>
        {intl.formatMessage(messages.Open)}
      </Button>

      <Dropdown.Toggle bsStyle="default" bsSize="xsmall" />
      <Dropdown.Menu>
        <MenuItem onSelect={() => onSendEmail(task)}>
          <FaRegEnvelope className="margin5R" />
          {intl.formatMessage(messages.SendEmail)}
        </MenuItem>

        <MenuItem onSelect={() => onShareItem(task)}>
          <FaShareAlt className="margin5R" />
          {intl.formatMessage(messages.Share)}
        </MenuItem>

        <CanDelete on={task.taskLevel === 2 ? 'Todo' : 'PlannedTask'}>
          <MenuItem onSelect={() => onDeleteTask(task)}>
            <FaTrashAlt className="text-danger margin5R" />
            {intl.formatMessage(messages.Delete)}
          </MenuItem>
        </CanDelete>
      </Dropdown.Menu>
    </Dropdown>
  );
};

TaskListActionsButton.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  intl: intlShape.isRequired,
  onOpenTask: PropTypes.func.isRequired,
  onSendEmail: PropTypes.func.isRequired,
  onShareItem: PropTypes.func.isRequired,
  onDeleteTask: PropTypes.func.isRequired,
};

export default injectIntl(TaskListActionsButton);
